module.exports = __webpack_public_path__ + "static/media/quadratic regression_supported.16ab53a9.png";